import { ParsedUrlQuery } from "node:querystring"
import { GetServerSidePropsContext, NextPageContext } from "next"
import * as Schema from "effect/Schema"
import * as O from "effect/Option"
import { CurrencyCode as CurrencyCodeCodec } from "@silversea-ssc/dotcom-read-model-types/CurrencyCodecs"
import { CurrencyCode } from "@silversea-ssc/dotcom-read-model-types/Currency"
import { BookingRouter, getFromQuery } from "./routing"
import { defaultGeoLocation, Geolocation } from "./providers/geolocation-provider"

const singleValue = (countryCodeHeader: string | string[] | undefined): string | undefined =>
    Array.isArray(countryCodeHeader) ? countryCodeHeader[0] : countryCodeHeader

export const countryFromContext = <T extends ParsedUrlQuery>(
    context: GetServerSidePropsContext<T> | NextPageContext,
): string => {
    const countryCodeHeader = context.req?.headers?.["x-country"]
    const countryCodeQuery = context.query["country"]
    return singleValue(countryCodeQuery) || singleValue(countryCodeHeader) || defaultGeoLocation.countryCode
}

export const countryFrom = (router: BookingRouter, geoLocation: Geolocation) =>
    getFromQuery(router, "country") || geoLocation.countryCode

export const currencyFrom = (router: BookingRouter, geoLocation: Geolocation): CurrencyCode => {
    const queryCurrency = getFromQuery(router, "currency")
    return Schema.validateOption(CurrencyCodeCodec)(queryCurrency).pipe(O.getOrElse(() => geoLocation.defaultCurrency))
}
